module.exports = ".admin-wrapper {\n  min-height: 550px;\n  margin-left: -1rem;\n  margin-top: -1rem; }\n\n.admin-wrapper a {\n  font-weight: 500; }\n\n.admin-wrapper .content-area {\n  margin-top: -1rem; }\n\n.clr-vertical-nav {\n  margin-top: -13px;\n  width: 305px;\n  margin-left: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.scss
// module id = ./src/app/admin/admin.component.scss
// module chunks = main